import SpouseEEForm from './spouseApplicantForm';
import PrincipalApplicantForm from './principalApplicantForm';
import { useState } from 'react';
import { Backdrop, Box, Button, CircularProgress, Divider, FormControlLabel, Stack, Switch } from '@mui/material';

function App() {
  //Principal Applicant form
  const [lang, setLang] = useState('en');
  const [hasSpouse, setHasSpouse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
      lastName: "",
      firstName: "",
      gender: "",
      dob: "",
      pob: "",
      marital: "",
      accompanying: "",
  
      passportNumber: "",
      passportCountry: "",
      passportIssue: "",
      passportExpiry: "",
      otherIDs: "",
      
      citizenship: "", //country of cityzenship
      residence: "",
      appliedIRCC: "",
      appliedEE: "",
      uci: "",
  
      familyMembers: "",//number family mem
      funds: "",
      relativeInCanada: "",
  
      hasEducation: "",//if has education
      education: [
        {
          school: "",
          field: "",
          place: "",
          postal: "",
          from: "",
          to: "",
          current: false,
          fullTime: "",
          years: "",
          level: "",
          standing: "",
          canadianAward: "",
          eca: "",
          canadianSchoolType: "",
          languageMajority: "",
          awardReturnHome: "",
          inPerson50: "",
          fullTime8Months: "",
          study8Months: "",
        },
      ],
      
      english: false,
      french: false,
      primaryLanguage: "",
      englishTestTaken: "",
      englishTest: "",
      englishTestDate: "",
      englishResultDate: "",
      englishCertNumber: "",
      english_speaking: "",
      english_reading: "",
      english_writing: "",
      english_listening: "",
      frenchTest: "",
      frenchTestTaken: "",
      frenchTestDate: "",
      frenchResultDate: "",
      frenchCertNumber: "",
      french_speaking: "",
      french_reading: "",
      french_writing: "",
      french_listening: "",
      // PROVINCE
      province: "",
      nomination: "",
      //Canadian certificate of qualification
      hasCertQualification: "",
      certProvince: "",
      certNoc: "",
      certDate:"",
  
      //Job offer in Canada 
      job: { 
        hasJob: "",
        fulltime: "",
        nonSeasonal: "",
        noc: "",
        title: "",
        employer: "",
        contactAddress: "",
        location: "",
        postal: "",
        lmia: "",
        howMany: "",
        employerTypes: [],
      },
      currentlyWorkingCanada: "",//if working in canada
      work: [
        {
          from: "",
          to: "",
          current: "",
          hours: "",
          noc: "",
          title: "",
          selfEmployed: "",
          employer: "",
          location: "",
          isCanadianExperience: "",
          legalInCanada: "",
          studyingFullTime: "",
          category: "",
        },
      ],
      research: { 
        action: "",
        educationCheck: "",
        educationCheckWith: [],
        regulated: "",
        regulatedAction: [],
      },
      declarationSigned: "",
      declarationDate:""
    });

  // Spouse Form
  const [formData, setFormData] = useState({
          noWorkHistory: false,
          currentlyWorkingInCanada:"",
          workHistory: [
              {
                  startDate: '',
                  endDate: '',
                  hoursPerWeek: '',
                  nocCode: '',
                  jobTitle: '',
                  employer: '',
                  address: '',
                  isCurrentJob: false,
                  isCanadianExperience: '',
                  legal: '',
                  fullTimeStudy: '',
                  permitType: ''
              }
          ],
          educationHistory: [
              {
                  schoolName: '',
                  field: '',
                  place: '',
                  postalCode: '',
                  startDate: '',
                  endDate: '',
                  isCurrent: '',
                  studyMode: '',
                  years: '',
                  level: '',
                  standing: '',
                  canadianAward: '',
                  eca: '',
                  isPublicOrPrivate: '',
                  languageCourse: '',
                  awardReturn: '',
                  inPerson: '',
                  monthsInCanada: '',
                  fullTime8Months: ''
              }
          ]
      });

  const handleSubmitAll = async (e) => {
  e.preventDefault();
  setLoading(true);

  // Build the final payload
  const payload = {
    principalFormData: form,
    spouseFormData: hasSpouse ? formData : null
  };

  try {
    const response = await fetch("https://newform.montrealvisa.ca/submit-ee-form", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`Server responded with ${response.status}`);
    }

    const data = await response.json();
    console.log("Server response:", data);

    alert(
      lang === "en"
        ? "Form submitted successfully!"
        : "Formulaire soumis avec succès!"
    );
  } catch (error) {
    console.error("Submission failed:", error);
    alert(
      lang === "en"
        ? "Submission failed. Please try again."
        : "Échec de la soumission. Veuillez réessayer."
    );
  } finally {
    setLoading(false);
  }
};

  return (
    <Stack spacing={3}>
      <Box display="flex" justifyContent="flex-end">
          <FormControlLabel control={<Switch checked={lang === 'fr'} onChange={() => setLang(lang === 'en' ? 'fr' : 'en')} />} label={lang==='en'?"English":"Français"} />
      </Box>
      <form onSubmit={handleSubmitAll} style={{ maxWidth: "90%", margin: "2rem auto" }}>
        <PrincipalApplicantForm
          form={form}
          setForm={setForm}
          setHasSpouse={setHasSpouse}
          lang={lang} />

        {hasSpouse && (
          <>
            <Divider sx={{ my: 3}} />
            <SpouseEEForm
              formData={formData}
              setFormData={setFormData}
              lang={lang}
            />
          </>
        )}
        <Button type="submit" variant="contained">
            Submit Application
        </Button>
      </form>
      <Backdrop open={loading} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Stack>
  );
}

export default App;
